import { FaChevronDown } from "react-icons/fa";
import { IoMdMenu } from "react-icons/io";
import { scrollToSection } from "../../../../utils/helpers";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { BENEFITS_ID, INTEGRATION_ID, WHY_CHAT_ME_ID } from "../../constant";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "antd";
import logoVN from "@/assets/images/logo-vn.png";

const items = [
  {
    key: "1",
    label: "Vietnam",
  },
  {
    type: "divider",
  },
  {
    key: "2",
    label: "English",
  },
];
const Header = () => {
  const navigate = useNavigate();
  const [isOpenNavbar, setIsOpenNavbar] = useState(false);
  return (
    <div className="bg-primary-5 fixed w-full z-[99]">
      <div className="h-[60px] md:h-[90px] px-4 bg-primary-5 flex justify-between items-center md:w-[90%] max-w-[1000px] m-auto box-border">
        <div className="flex gap-1 items-center justify-center gap-2 cursor-pointer">
          {/* logo */}
          <img
            src="/media/images/landing-page/bot-icon-1.png"
            alt="chat_bot"
            className="w-[31px] w-[31px] md:w-[42px] md:h-[42px]"
          />
          <div>
            <div className="text-primary-1 uppercase  font-semibold">
              chatme.vn
            </div>
            <div className="text-white uppercase text-center text-xs">
              ai chatbot
            </div>
          </div>
        </div>
        <IoMdMenu
          className="text-white text-[32px] block md:hidden cursor-pointer hover:text-primary-1"
          onClick={() => setIsOpenNavbar(true)}
        />
        {isOpenNavbar && (
          <div className="fixed right-0 top-0 w-full h-[100vh] z-5 p-5 bg-black flex flex-col gap-2 text-white font-semibold">
            <div className="flex justify-end items-center">
              <IoMdClose
                className="text-[24px] hover:text-primary-1 cursor-pointer"
                onClick={() => setIsOpenNavbar(false)}
              />
            </div>
            <hr />
            <ul className="flex flex-col gap-3 py-2">
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  scrollToSection(WHY_CHAT_ME_ID);
                  setIsOpenNavbar(false);
                }}
              >
                Why Chatme
              </li>
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  scrollToSection(BENEFITS_ID);
                  setIsOpenNavbar(false);
                }}
              >
                Benefits
              </li>
              <li
                className="hover:text-primary-1 cursor-pointer"
                onClick={() => {
                  scrollToSection(INTEGRATION_ID);
                  setIsOpenNavbar(false);
                }}
              >
                Integration
              </li>
            </ul>
          </div>
        )}
        <ul className="flex gap-6 text-white hidden md:flex">
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => scrollToSection(WHY_CHAT_ME_ID)}
          >
            Why Chatme
          </li>
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => scrollToSection(BENEFITS_ID)}
          >
            Benefits
          </li>
          <li
            className="hover:text-primary-1 cursor-pointer"
            onClick={() => scrollToSection(INTEGRATION_ID)}
          >
            Integration
          </li>
        </ul>
        <div className="flex justify-center items-center gap-6 hidden md:flex">
          <div
            className="w-[142px] h-[40px] border border-[#50b553] bg-primary-2 rounded-[11px] text-primary-1 flex items-center justify-center cursor-pointer hover:text-white"
            onClick={() => navigate("/auth/login")}
          >
            Join Now
          </div>
          {/* language selection */}
          <div className="flex justify-center items-center gap-2 text-white">
            <Dropdown menu={{ items }} trigger={["click"]}>
              <>
                <div>VN</div>
                <img
                  src={logoVN}
                  alt="vn-logo"
                  className="w-[18px] h-[12px]"
                />
                <a
                  onClick={(e) => e.preventDefault()}
                  className="cursor-pointer"
                >
                  <FaChevronDown />
                </a>
              </>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
